import { render } from "./CustomizeOverview.vue?vue&type=template&id=0b9ba6c4"
import script from "./CustomizeOverview.vue?vue&type=script&lang=js"
export * from "./CustomizeOverview.vue?vue&type=script&lang=js"

import "./CustomizeOverview.vue?vue&type=style&index=0&id=0b9ba6c4&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__